/* Product-page coordination. All image loading belongs to ThemeProductImages. */
(() => {
  if (window.ProductMedia2026) return;
  const init = root => window.ThemeProductImages?.init(root || document);
  const load = image => window.ThemeProductImages?.load(image);
  window.ProductMedia2026 = { init, load };
  document.addEventListener('variant:change', event => {
    const { mediaId, sectionId } = event.detail || {};
    if (!mediaId) return;
    const root = sectionId
      ? document.querySelector(`[data-product-section][data-section-id="${CSS.escape(String(sectionId))}"]`)
      : document.querySelector('[data-product-section]');
    if (!root) return;
    const selector = `[data-media-id="${CSS.escape(String(mediaId))}"]`;
    const sliderImage = root.querySelector('.main-slider img' + selector);
    if (sliderImage) {
      const swiper = sliderImage.closest('.main-slider')?.swiper;
      const index = Number(sliderImage.dataset.index);
      if (swiper && Number.isFinite(index)) swiper.params.loop ? swiper.slideToLoop(index) : swiper.slideTo(index);
      load(sliderImage);
      return;
    }
    const thumbnail = root.querySelector('.stacked-thumbnails img' + selector);
    const hero = root.querySelector('.main-image img.feature');
    if (!thumbnail || !hero) return;
    const src = thumbnail.dataset.variantSrc || thumbnail.src;
    hero.dataset.mediaId = mediaId;
    hero.dataset.index = thumbnail.dataset.index;
    hero.alt = thumbnail.alt;
    if (hero.hasAttribute('data-zoom')) hero.dataset.zoom = src;
    // The hero uses its own display size, never a thumbnail's selected bitmap.
    const url = new URL(src, location.href);
    const srcset = [240,480,720,960,1200,1600].map(width => {
      url.searchParams.set('width', width); return `${url.href} ${width}w`;
    }).join(', ');
    window.ThemeProductImages?.load(hero, { src, srcset, preview: thumbnail.dataset.productPreview });
  });
  init();
})();
